import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "texttypealignments"
    }}>{`TextTypeAlignments`}</h1>
    <p>{`The text alignment relative to the path.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ASCENDER_TEXT_ALIGNMENT`}</strong>{` = 1952538995`}</p>
      <p parentName="blockquote">{`Aligns the ascender to the path (not the path's stroke).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DESCENDER_TEXT_ALIGNMENT`}</strong>{` = 1952539763`}</p>
      <p parentName="blockquote">{`Aligns descender to the path (not the path's stroke).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CENTER_TEXT_ALIGNMENT`}</strong>{` = 1952539508`}</p>
      <p parentName="blockquote">{`Aligns the midpoint between the ascender and the descender to the path (not the path's stroke).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BASELINE_TEXT_ALIGNMENT`}</strong>{` = 1952539244`}</p>
      <p parentName="blockquote">{`The text baseline is aligned to the path (not the path's stroke).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ABOVE_RIGHT_EM_BOX_TEXT_ALIGNMENT`}</strong>{` = 1952543333`}</p>
      <p parentName="blockquote">{`The top-edge or right-edge baseline of the em box is aligned to the path.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BELOW_LEFT_EM_BOX_TEXT_ALIGNMENT`}</strong>{` = 1952607333`}</p>
      <p parentName="blockquote">{`The bottom-edge or left-edge baseline of the em box is aligned to the path.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ABOVE_RIGHT_ICF_BOX_TEXT_ALIGNMENT`}</strong>{` = 1952543337`}</p>
      <p parentName="blockquote">{`The ideographic character face box top-edge or right-edge baseline is aligned to the path.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BELOW_LEFT_ICF_BOX_TEXT_ALIGNMENT`}</strong>{` = 1952607337`}</p>
      <p parentName="blockquote">{`The ideographic character face box bottom-edge or left-edge baseline is aligned to the path.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      